import React from 'react';
import {translate} from 'react-i18next';
import Setting from "../components/Setting";
import {url} from "../../../../systems/routing";
import {setActiveSettingItem} from '../../SettingMenu/actions';

class BuyingSettingComponent extends React.Component {

    componentDidMount() {
        let {t} = this.props;
        this.props.setPageTitle(t('breadcrumb.setting-buying'));
        this.props.setPageDescription(t('setting-buying.detail'));
        this.props.setBreadCrumb([
            {
                'label': 'breadcrumb.home',
                'link': '/'
            },
            {
                'label': 'breadcrumb.setting-buying',
                'link': url.to('setting-buying')
            },
        ]);
        this.props.setMenuActive("setting-buying");
        setActiveSettingItem('setting-buying');
        this.props.fetchConfigSystem();
    }

    render() {
        let {
            configSetting,
            updateConfigSystem,
            loading,
            t
        } = this.props;

        // permissionGroup: là nhóm quyền endpoint trả về để client nhận biết các cấu hình được chỉnh sửa ở mỗi page
        return (
            <div className="a-content__right">
                {
                    configSetting ?
                        <Setting
                            configSetting={configSetting}
                            loading={loading}
                            updateConfigSystem={updateConfigSystem}
                            permissionGroup="buyingSettings"
                        /> :
                        <div className="a-setting__block a-content--box-shadow">
                            <p className={"d-flex justify-content-center"}>{t("setting:no_record_global")}</p>
                        </div>
                }
            </div>
        );
    }
}

BuyingSettingComponent.defaultProps = {};
BuyingSettingComponent.propTypes = {};

export default translate('translations')(BuyingSettingComponent);
